import React, { /*useCallback,*/ useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const Profil = () => {
    const [isTokenExpired, setIsTokenExpired] = useState(false);

    const [data, setData] = useState({
        id: 0,
        ad: "",
        soyad: "",
        telefonCep: "",
        telefonIs: "",
    });

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value,});
    };

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        
        try {
            const token = localStorage.getItem('ATGroupToken');
            const decodedToken = decodeToken(token);
            const userId = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

            const result = await axios.get(settings.ApiUrl + 'Kullanici/GetKullanici/' + userId, { headers: AuthService.getHeaders() });

            if (result && result.data) {
                setData(result.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        
        if (data.ad === "" || data.soyad === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            const postData = JSON.stringify({
                "id": data.id,
                "ad": data.ad,
                "soyad": data.soyad,
                "telefoncep": data.telefonCep,
                "telefonis": data.telefonIs
            });
    
            try {
                const result = await axios.post(settings.ApiUrl + 'Kullanici/UpdateKisiProfil/', postData, { headers: AuthService.getHeaders() });    

                if (result && result.data){
                    toast.success("Kaydedildi");
                }
            } catch (error) {
                toast.error("Hata oluştu: " + error);
            }
        }
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    <div className="card info-card mb-2">
                        <div className="card-body">
                            <h5 className="card-title">Profil Bilgileriniz</h5>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblAd" style={{width:"120px"}}>Ad<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <input name="ad" aria-describedby="lblAd" type="text" className="form-control form-control-sm" value={data.ad} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblSoyad" style={{width:"120px"}}>Soyad<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <input name="soyad" aria-describedby="lblSoyad" type="text" className="form-control form-control-sm" value={data.soyad} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblTelefonCep" style={{width:"120px"}}>Cep Telefonu</label>
                                        <input name="telefonCep" aria-describedby="lblTelefonCep" type="text" className="form-control form-control-sm" value={data.telefonCep} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblTelefonIs" style={{width:"120px"}}>İş Telefonu</label>
                                        <input name="telefonIs" aria-describedby="lblTelefonIs" type="text" className="form-control form-control-sm" value={data.telefonIs} onChange={handleChange}></input>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button className="btn btn-success w-100" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
        </Fragment>
    );
};

export default Profil;